import { render, staticRenderFns } from "./ebookDetail.vue?vue&type=template&id=8f0f5b4c&scoped=true&"
import script from "./ebookDetail.vue?vue&type=script&lang=js&"
export * from "./ebookDetail.vue?vue&type=script&lang=js&"
import style0 from "./ebookDetail.vue?vue&type=style&index=0&id=8f0f5b4c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f0f5b4c",
  null
  
)

export default component.exports